import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useContext } from "react";
import { Stack, Dialog, DialogTitle, DialogContent } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { ExtraSmallFab } from "./Buttons/ExtraSmallFAB";
/**
 * Modal context
 *
 */
const ModalContext = React.createContext({
    showModal: () => {
        return;
    },
    closeModal: () => {
        return;
    },
});
/**
 * useModal - Hook to get the global modal context state.
 *
 * @return {*}  {ModalContextState}
 */
export const useModal = () => useContext(ModalContext);
/**
 * Modal Container
 * This should be placed at the root of the application.
 *
 * @param {*} {children}
 * @returns
 */
export const ModalContainer = ({ children }) => {
    var _a, _b, _c;
    const [modalProps, setModalProps] = useState(undefined);
    /**
     * showModal() opens the modal.
     *
     * @param {ConfirmProps} mprops
     */
    const showModal = (mprops) => {
        setModalProps(mprops);
    };
    /**
     *  closeModal() - close Modal
     *
     */
    const closeModal = () => {
        (modalProps === null || modalProps === void 0 ? void 0 : modalProps.closeModalFunc) ? modalProps.closeModalFunc() : undefined;
        setModalProps(undefined);
    };
    return (_jsxs(ModalContext.Provider, Object.assign({ value: { closeModal, showModal } }, { children: [children, modalProps && (_jsxs(Dialog, Object.assign({ fullScreen: (_a = modalProps.fullScreen) !== null && _a !== void 0 ? _a : false, fullWidth: (_b = modalProps.fullWidth) !== null && _b !== void 0 ? _b : false, maxWidth: (_c = modalProps.maxWidth) !== null && _c !== void 0 ? _c : "sm", open: modalProps != undefined }, { children: [_jsx(DialogTitle, Object.assign({ style: Object.assign({}, modalProps.titleStyles) }, { children: _jsxs(Stack, Object.assign({ direction: "row", justifyContent: "space-between", alignItems: "center" }, { children: [typeof modalProps.title === "string" ? (_jsx(Typography, Object.assign({ variant: "h3" }, { children: modalProps.title }))) : (modalProps.title), !modalProps.hideCloseButton && (_jsx(ExtraSmallFab, { icon: CloseIcon, "aria-label": "close", onClick: () => closeModal() }))] })) })), modalProps.content, modalProps.actions] })))] })));
};
export const ModalContent = DialogContent;
